import React from 'react';

class Logo extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'Logo';
  }


  /**
   * Renders component
   * @returns {ReactElement} React element
   */
  render() {
    const className = 'component-logo';
    const url = this.props.url || 'http://bleacherreport.com';

    return (
      <a
        className={className}
        href={url}
        target='_blank'
      >
      </a>
    );
  }
}


/**
 * @prop {String} url - The url for the logo anchor tag
 */
Logo.propTypes = {
  url: React.PropTypes.string,
};


export default Logo;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Logo.jsx
 **/